import React, { useEffect, useState } from 'react';
import './AffiliationPage.scss'; // Affiliation Page SCSS
import AOS from 'aos';
import 'aos/dist/aos.css';
import Header from '../../components/ActivePath/Header';

const AffiliationPage: React.FC = () => {
  const [modalOpen, setModalOpen] = useState(false);
  const [selectedYear, setSelectedYear] = useState<string | null>(null);
  const reports = [
    "EOA Report 2019-20",
    "EOA Report 2020-21",
    "EOA Report 2021-22",
    "EOA Report 2022-23",
    "EOA Report 2023-24",
    "EOA Report 2024-25",
    "EOA Report 2025-26",
    "EOA Report 2026-27"
  ];

  useEffect(() => {
    AOS.init({ duration: 1200 });
  }, []);

  const handleDownload = (report: string) => {
    const year = report.split(' ')[2];
    const pdfPath = `/pdfs/EOA_Report_${year}.pdf`;
    const link = document.createElement('a');
    link.href = pdfPath;
    link.download = `EOA_Report_${year}.pdf`;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    setModalOpen(false);
  };
  
  return (
    <div className="affiliation-page">
      {/* Header Section */}
      <Header pageTitle="" breadcrumb="Affiliation" />
      
      {/* Content Section */}
      <div className="content">
        <div className="content-wrapper" data-aos="fade-up">
          <h2>Affiliation & Recognition</h2>
          <p>
            The Sri Jagadguru Murugharajendra Polytechnic (SJMP) is proud to be affiliated by the Department of Technical Education, Bengaluru, Karnataka, and is recognized/approved by the All India Council for Technical Education (AICTE), New Delhi.
          </p>
          <p>
            The college is committed to providing high-quality technical education in accordance with the standards set by AICTE. As part of our ongoing efforts to maintain and exceed academic standards, we continually work towards ensuring the best education for our students.
          </p>
          <div className="ai-file">
            <h3>Click below for AICTE Approval Files</h3>
             {/* Download Button */}
          <div className="ai-approval-link">
            <button onClick={() => setModalOpen(!modalOpen)} className="download-btn">EOA Reports</button>
          </div>
          {/* Modal Popup */}
          {modalOpen && (
            <div className="modal-overlay">
              <div className="modal-content">
                <h3>Download EOA Report</h3>
                <ul>
                  {reports.map(report => (
                    <li key={report}>
                      <button onClick={() => handleDownload(report)}>{report}</button>
                    </li>
                  ))}
                </ul>
                <button onClick={() => setModalOpen(false)} className="close-btn">Close</button>
              </div>
            </div>
          )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default AffiliationPage;
